import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../dashboard/Sidebar';
import { Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function DashboardLayout({ children }) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate('/auth/login');
      return;
    }
  }, []);

  return (
    <>
      <div className="dashboard-content">
        <Row>
          <Col lg="12">
            <Sidebar />
          </Col>
          <Col lg="12">
            <main className="main-content mt-4">{children}</main>
          </Col>
        </Row>
      </div>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
